import React, { useEffect, useState } from 'react';

/**
 * Slim progress bar that fills as the user scrolls down the page.
 * Sits above everything except the nav (z-index 90).
 */
const ScrollProgress = () => {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const y = window.scrollY;
      setPct(max > 0 ? Math.min(100, (y / max) * 100) : 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="scroll-progress" aria-hidden="true">
      <span style={{ width: `${pct}%` }} />
    </div>
  );
};

export default ScrollProgress;
